<template>
  <v-card flat class="pa-0" v-resize="onResize">
    <v-img class="white--text align-center tone-color" :height="getHeight">
      <v-card class="mx-auto login" flat max-width="380">
        <v-sheet class="v-sheet--offset mx-auto pl-2 pr-2" max-width="calc(100% - 60%)">
          <v-img height="100" contain :src="require('../../assets/logo.png')"></v-img>
        </v-sheet>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout column>
            <v-layout justify-center class="mt-2 mb-2">
              <v-btn
                color="primary"
                class="mr-4"
                :loading="microsoftLoading"
                @click="getSharepointUrl"
              >
                <v-icon>mdi-microsoft-office</v-icon>
                {{ $t('message.login.office365') }}
              </v-btn>
            </v-layout>
            <p class="text-center my-4 font-weight-bold">--------({{ $t('message.login.or') }})--------</p>
            <v-form ref="loginForm" autocomplete="off">
              <v-text-field
                v-model="model.username"
                class="mt-1"
                filled dense
                append-icon="person"
                :rules="$_requiredValidation"
                id="username_field"
                :label="$t('message.login.userName')"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="model.password"
                filled dense
                id="password_field"
                :rules="$_requiredValidation"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @keyup.enter="loginHandler"
                :label="$t('message.login.password')"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
              <v-select
                append-icon="language"
                id="lang_select"
                filled dense
                :label="$t('message.login.language')"
                :items="language"
                v-model="defaultLang"
                item-text="title"
                item-value="value"
              ></v-select>
              <!-- <v-layout justify-end>
                <a @click="$router.push('/forgotpassword')"><b>{{$t('message.login.forgotPassword')}}</b></a>
              </v-layout> -->
              <v-layout justify-center class="mt-5">
                <v-btn
                  color="primary"
                  class="mr-4"
                  :loading="loading"
                  @click="loginHandler"
                >
                <v-icon>mdi-login-variant</v-icon>
                {{ $t('message.layout.login') }}
              </v-btn>
              </v-layout>
            </v-form>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-img>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      model: {
        username: '',
        password: '',
        code: ''
      },
      defaultLang: this.$i18n.locale || 'no',
      showPassword: false,
      getHeight: 900,
      microsoftLoading: false
    }
  },
  computed: {
    language () {
      return [
        { title: this.$t('message.common.english'), value: 'en' },
        { title: this.$t('message.common.norwegian'), value: 'no' }
      ]
    }
  },
  watch: {
    defaultLang () {
      this.$i18n.locale = this.defaultLang
    }
  },
  mounted () {
    if (this.$route.query.code) {
      this.model.code = this.$route.query.code
      this.loginHandler()
    }
    this.getHeight = (window.innerHeight - 30)
  },
  methods: {
    onResize () {
      this.getHeight = (window.innerHeight - 24)
    },
    getSharepointUrl () {
      this.microsoftLoading = true
      this.$_executeApi('get', 'auth/get_sharepoint_auth_url').then(({ data }) => {
        window.open(data.url, '_self')
      }).finally(() => { this.microsoftLoading = true })
    },
    loginHandler () {
      if (this.$route.query.code ? true : this.$refs.loginForm.validate()) {
        if (this.model.code) this.microsoftLoading = true
        else this.loading = true
        this.$store.dispatch('login', this.model)
          .then((response) => {
            this.$root.$emit('setSignalrAndNotification')
            if (response && !response.sharepointconfigdone) {
              this.$router.push('/sharepoint')
            } else {
              this.$router.push({ path: this.$route.query.redirect || 'customers' })
            }
          }).finally(() => {
            if (this.model.code) this.microsoftLoading = false
            else this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  }
}
</script>
<style>
.login .v-sheet--offset {
  position: relative;
}
.login {
  border-radius: 18px !important;
}
.tone-color {
  background: #f8fdff;
}
</style>
